<template>
  <v-layout row wrap justify-center pa-4 v-if="show">
    <v-flex xs12 lg8>
      <v-alert color="error" class="err" :value="true" icon="warning" type="error" v-if="err">
        {{err}}
      </v-alert>
      <v-card class="mb-4" flat>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">{{$lang.header.companyInfo}}</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">{{$lang.header.companySettings}}</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">{{$lang.header.account}}</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat
                      class="mb-5"
              >
                <v-form v-model="valid1">
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12>
                      <h2 class="px-3 pb-3">
                        {{ $lang.header.companyGeneralData }}
                      </h2>
                    </v-flex>
                    <v-flex xs12 sm6 md4 px-3>
                      <v-text-field
                        :label="$lang.labels.name"
                        :placeholder="$lang.placeholders.companyName"
                        :rules="[v => !!v || `${$lang.errors.missingCompanyName}`]"
                        type="text"
                        id="name"
                        v-model="company.name"
                        required
                        :hint="company.name.length > 12 ? 'Name will be shortened on webshop in mobile view' : ''"
                        persistent-hint
                        class="required"/>
                      <v-text-field
                        :label="$lang.labels.email"
                        :placeholder="$lang.placeholders.companyEmail"
                        type="email"
                        id="email"
                        required
                        class="required"
                        v-model="company.email"
                        :rules="emailRules"/>
                    </v-flex>
                    <v-flex xs12 sm6 md4 px-3>
                      <v-text-field
                        :label="$lang.labels.registrationNumber"
                        type="text"
                        id="registrationNumber"
                        v-model="company.registrationNumber"/>
                      <v-text-field
                        :label="$lang.labels.phone"
                        :placeholder="$lang.placeholders.phone"
                        :rules="[v => !!v || `${$lang.errors.missingCompanyPhone}`]"
                        required
                        class="required"
                        type="text"
                        id="phone"
                        v-model="company.phone"/>
                    </v-flex>
                    <v-flex xs12 sm6 md4 px-3>
                      <v-text-field
                        :label="$lang.labels.registrationLocation"
                        type="text"
                        id="registrationLocation"
                        v-model="company.registrationLocation"/>
                      <v-select
                        :rules="[company.cuisines.length !== 0 || `${$lang.errors.missingCuisines}`]"
                        required
                        class="required"
                        multiple
                        small-chips
                        deletable-chips
                        :items="cuisines"
                        v-model="company.cuisines"
                        :label="$lang.labels.cuisines"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12>
                      <h2 class="px-3 pb-3">
                        {{ $lang.header.companyAddress }}
                      </h2>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <v-select
                        :label="$lang.labels.country"
                        :placeholder="$lang.placeholders.companyCountry"
                        :rules="[v => !!v || `${$lang.errors.missingCompanyCountry}`]"
                        :items="countries"
                        type="text"
                        id="country"
                        v-model="company.address.country"
                        required
                        class="required"
                      />
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <v-btn block @click="addressDialog = true" :disabled="company.address.country === ''"
                             class="primary mx-0 mb-4">{{ $lang.labels.addressLookup }}
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 px-3 v-if="company.address.latitude && company.address.longitude">
                      <div class="rest-desc text-xs-left">
                        <h3>{{$lang.labels.selectedAddress}}:</h3>
                        <p class="mb-0">
                          {{
                            generateAddress([
                              company.address.line1,
                              company.address.line2,
                              company.address.line3,
                              company.address.line4,
                            ])
                          }}</p>
                        <p class="mb-0">
                          {{ company.address.locality ? company.address.locality + ', ' : '' }}
                          {{
                            company.address.country === 'UK' ? company.address.townCity : company.address.postalCode
                          }},
                          {{ company.address.country === 'UK' ? company.address.postalCode : company.address.townCity }}
                        </p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card>

              <v-layout row wrap justify-space-between>
                <v-btn flat :to="{ name: 'logIn' }">{{$lang.actions.cancel}}</v-btn>
                <v-btn
                  :disabled="!valid1 || !addressSet"
                  color="primary"
                  @click="e1 = 2"
                >
                  {{$lang.actions.next}}
                </v-btn>
              </v-layout>

            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card flat
                      class="mb-5"
              >
                <v-form v-model="valid2">
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12>
                      <h2 class="px-3 pb-3">
                        {{ $lang.header.companySettings }}
                      </h2>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <v-flex xs12 sm6>
                        <v-checkbox
                          v-model="company.dailyOrdersCounterEnabled"
                          class="option"
                          hide-details
                          color="primary"
                          :label="$lang.labels.dailyOrdersCounterEnabled"
                        />
                      </v-flex>
                    </v-flex>
                    <v-flex xs12 px-3 pt-4>
                      <v-autocomplete
                        :label="$lang.labels.paymentTypes"
                        :placeholder="$lang.placeholders.paymentTypes"
                        multiple
                        chips
                        deletable-chips
                        :items="payments"
                        v-model="company.paymentTypes"
                        required
                        class="required"
                        :rules="[company.paymentTypes.length > 0 || `${$lang.errors.missingPayments}`]"
                      />
                    </v-flex>
                    <v-flex xs12 px-3>
                      <v-btn @click="addHours" :disabled="editingHours" class="primary mx-0">
                        {{ $lang.actions.openingHours }}
                      </v-btn>
                      <transition name="fade">
                        <div class="v-table__overflow custom-table">
                          <table class="v-datatable v-table theme--light">
                            <thead v-if="openingTimes.length !== 0">
                            <tr>
                              <td class="move-row"/>
                              <th class="text-xs-left">
                                <div class="th-adj">{{ $lang.header.day }}<span class="error--text">*</span></div>
                              </th>
                              <th class="text-xs-left">
                                <div class="th-adj">{{ $lang.header.start }}<span class="error--text">*</span></div>
                              </th>
                              <th class="text-xs-left">
                                <div class="th-adj">{{ $lang.header.end }}<span class="error--text">*</span></div>
                              </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                              v-for="(time, index) in openingTimes"
                              :key="index">
                              <template v-if="time.isEdit">
                                <td class="move-row"/>
                                <td>
                                  <v-select
                                    class="min-w"
                                    :items="days"
                                    v-model="tempOpening.day"
                                  />
                                </td>
                                <td>
                                  <v-text-field
                                    v-model="tempOpening.start"
                                    type="text"
                                    mask="##:##"
                                    placeholder="HH:mm"
                                    required
                                    class="required"
                                    :rules="timeRule"/>
                                </td>
                                <td>
                                  <v-text-field
                                    type="text"
                                    v-model="tempOpening.end"
                                    mask="##:##"
                                    placeholder="HH:mm"
                                    required
                                    class="required"
                                    :rules="timeRule"
                                  />
                                </td>
                                <td style="min-width: 314px;" class="px-0">
                                  <v-btn
                                    class="primary elevation-1 mx-0"
                                    :disabled="!openingValidation"
                                    @click="saveOpening(time)">
                                    {{ $lang.actions.save }}
                                  </v-btn>
                                  <v-btn
                                    class="primary elevation-1"
                                    :disabled="!openingValidation"
                                    @click="copyOpening(time)">
                                    {{ $lang.actions.copy }}
                                  </v-btn>
                                  <v-btn class="error mx-0 elevation-1" @click="closeOpening(time)">
                                    {{ $lang.actions.cancel }}
                                  </v-btn>
                                </td>
                              </template>
                              <template v-else>
                                <td class="move-row">
                                  <div v-if="openingTimes.length >= 2">
                                    <v-icon @click="moveUp(openingTimes, index)" v-if="index !== 0">keyboard_arrow_up
                                    </v-icon>
                                    <v-icon @click="moveDown(openingTimes, index)"
                                            v-if="index != openingTimes.length - 1">keyboard_arrow_down
                                    </v-icon>
                                  </div>
                                </td>
                                <td>{{ time.day }}</td>
                                <td>{{ time.start }}</td>
                                <td>{{ time.end }}</td>
                                <td style="min-width: 314px;" class="px-0">
                                  <v-btn class="primary elevation-1 mx-0" @click="editOpening(time)"
                                         :disabled="editingHours">
                                    {{ $lang.actions.edit }}
                                  </v-btn>
                                  <v-btn
                                    class="primary elevation-1"
                                    @click="copyOpening(time)">
                                    {{ $lang.actions.copy }}
                                  </v-btn>
                                  <v-btn class="error mx-0 elevation-1" @click="deleteOpening(index)">
                                    {{ $lang.actions.delete }}
                                  </v-btn>
                                </td>
                              </template>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </transition>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12 px-3 pb-2 mt-3>
                    <v-layout row align-center>
                      <v-btn
                        :disabled="editingVat || noTax"
                        class="primary ml-0 mr-3"
                        @click="addVat">
                        {{ $lang.actions.addVat }}
                      </v-btn>
                      <v-checkbox
                        v-model="noTax"
                        :label="$lang.labels.noVATtax"
                        hide-details
                        color="primary"
                      />
                    </v-layout>
                    <transition name="fade">
                      <div class="v-table__overflow custom-table">
                        <table class="v-datatable v-table theme--light">
                          <tbody>
                          <tr
                            v-for="(vat, index) in vatRates"
                            :key="index">
                            <template v-if="vat.isEdit">
                              <td>
                                <v-text-field
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  class="min-w mb-2 required"
                                  required
                                  hide-details
                                  v-model="tempVat.vat"
                                  :label="$lang.actions.addVat"/>
                              </td>
                              <td class="min-w-lg px-0">
                                <v-btn class="primary elevation-1" :disabled="!tempVat.vat" @click="saveVatEdit(vat)">
                                  {{ $lang.actions.save }}
                                </v-btn>
                                <v-btn class="error ml-0 elevation-1" @click="closeVatEdit(vat)">
                                  {{ $lang.actions.cancel }}
                                </v-btn>
                              </td>
                            </template>
                            <template v-else>
                              <td>{{ vat.vat }}</td>
                              <td class="actions px-0">
                                <v-btn class="primary elevation-1" @click="editVat(vat)">{{
                                    $lang.actions.edit
                                  }}
                                </v-btn>
                                <v-btn class="error ml-0 elevation-1" @click="deleteVat(index)">
                                  {{ $lang.actions.delete }}
                                </v-btn>
                              </td>
                            </template>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </transition>
                    <v-layout row wrap pt-2>
                      <v-flex xs10 px-1>
                        <v-layout row align-center>
                          <v-flex grow>
                            <v-select
                              :label="$lang.labels.tipTax"
                              :items="vatRates"
                              type="number"
                              step="0.5" min="0"
                              v-model="company.tipTaxRate"
                              :disabled="noTipTax"
                              item-text="vat"
                              item-value="vat"
                            />
                          </v-flex>
                          <v-flex shrink>
                            <v-checkbox
                              v-model="noTipTax"
                              :label="$lang.labels.noTipTax"
                              hide-details
                              :disabled="this.vatRates.length === 0"
                              class="ml-3"
                              color="primary"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs10 px-1>
                        <v-layout row align-center>
                          <v-flex grow>
                            <v-select
                              :label="$lang.labels.chargeTax"
                              :items="vatRates"
                              v-model="company.deliveryChargesTaxRate"
                              :disabled="noDeliveryTax"
                              item-text="vat"
                              item-value="vat"
                            />
                          </v-flex>
                          <v-flex shrink>
                            <v-checkbox
                              v-model="noDeliveryTax"
                              :label="$lang.labels.noDeliveryTax"
                              hide-details
                              :disabled="this.vatRates.length === 0"
                              class="ml-3"
                              color="primary"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-card>

              <v-layout row wrap justify-space-between>
                <v-btn flat @click="e1 = 1">{{$lang.actions.back}}</v-btn>
                <v-btn
                  :disabled="company.address.country === 'AT' ? !valid2 || !vatRates || (vatRates && vatRates.length === 0) : !valid2"
                  color="primary"
                  @click="e1 = 3"
                >
                  {{$lang.actions.next}}
                </v-btn>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card flat
                      class="mb-5"
              >
                <v-form v-model="valid3">
                  <v-layout row wrap class="px-2">
                    <v-flex xs12>
                      <h2 class="px-3 pb-3">
                        {{ $lang.labels.account }}
                      </h2>
                    </v-flex>
                    <v-flex xs12 md6 px-3>
                      <v-text-field
                        :label="$lang.labels.holder"
                        v-model="account.name"
                        required
                        :rules="[v => !!v || `${$lang.errors.missingHolder}`]"
                      />
                    </v-flex>
                    <v-flex xs12 md6 px-3>
                      <v-text-field
                        :label="$lang.labels.username"
                        v-model="account.userName"
                        :hint="$lang.labels.lowerCase"
                        @blur="account.userName ? account.userName = account.userName.toLowerCase().trim() : ''"
                        required
                        :rules="[v => !!v || `${$lang.errors.missingUserName}`]"
                      />
                    </v-flex>
                    <v-flex xs12 md6 px-3>
                      <v-text-field
                        :label="$lang.labels.email"
                        type="email"
                        v-model="account.email"
                        :rules="emailRules"
                      />
                    </v-flex>
                    <v-flex xs12 md6 px-3>
                      <v-text-field
                        :label="$lang.labels.confirmEmail"
                        type="email"
                        v-model="confirmEmail"
                        :rules="[v => (!!v && v === account.email) || `${$lang.errors.validConfirmEmail}`]"
                      />
                    </v-flex>
                    <v-flex xs12 md6 px-3>
                      <v-text-field
                        :label="$lang.labels.maxDiscountPercentage"
                        v-model="account.maxDiscountPercentage"
                      />
                    </v-flex>
                    <v-flex xs12 px-3>
                      <v-text-field
                        :label="$lang.labels.notes"
                        v-model="account.notes"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card>

              <v-layout row wrap justify-space-between>
                <v-btn flat @click="e1 = 2">{{$lang.actions.back}}</v-btn>
                <v-btn
                  :disabled="!valid3"
                  color="primary"
                  @click="submit()"
                >
                  {{$lang.actions.submit}}
                </v-btn>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-flex>
    <v-dialog scrollable :fullscreen="$vuetify.breakpoint.smAndDown" v-model="addressDialog" v-if="addressDialog"
              max-width="600px">
      <address-modal @close="addressDialog = false" :country="company.address.country" :address="company.address"
                     :postal="company.address.postalcode" @submit="submitAddress"/>
    </v-dialog>
  </v-layout>
</template>

<script>
import Cookie from "vue-cookie";
import {DateTime} from 'luxon';

export default {
  components: {
    addressModal: () => import('./modals/AddressModal'),
  },
  data() {
    return {
      show: false,
      valid1: false,
      valid2: false,
      valid3: false,
      addressSet: false,
      confirmEmail: '',
      addressDialog: false,
      timeRule: [
        v => /^([01]\d|2[0-3]):?([0-5]\d)$/.test(v) || this.$lang.errors.validTime
      ],
      emailRules: [
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$lang.errors.validEmail
      ],
      days: [
        {text: this.$lang.labels.sunday, value: 'SUNDAY'},
        {text: this.$lang.labels.monday, value: 'MONDAY'},
        {text: this.$lang.labels.tuesday, value: 'TUESDAY'},
        {text: this.$lang.labels.wednesday, value: 'WEDNESDAY'},
        {text: this.$lang.labels.thursday, value: 'THURSDAY'},
        {text: this.$lang.labels.friday, value: 'FRIDAY'},
        {text: this.$lang.labels.saturday, value: 'SATURDAY'},
        {text: this.$lang.labels.publicHoliday, value: 'PUBLICHOLIDAY'},
      ],
      openingTimes: [],
      tempOpening: {
        day: '',
        start: '',
        end: '',
      },
      editingHours: false,
      validHours: false,

      vatRates: [],
      tempVat: {
        vat: '',
      },
      editingVat: false,
      valid: false,
      isEdit: false,
      align: 'left',
      allowedVatRates: {},
      company: {
        name: '',
        email: '',
        phone: '',
        currency: '',
        paymentTypes: [],
        tipTaxRate: null,
        defaultLanguage: '',
        cuisines: [],
        deliveryChargesTaxRate: null,
        dailyOrdersCounterEnabled: false,
        address: {
          line1: '',
          line2: '',
          line3: '',
          line4: '',
          locality: '',
          townCity: '',
          country: '',
          postalCode: '',
          latitude: '',
          longitude: '',
        },
        registrationNumber: '',
        registrationLocation: '',
        timezone: '',
        distanceUnit: '',
      },
      err: '',
      success: '',
      language: this.$cookie.get('lang') || 'en',
      cuisines: [],
      snackbar: false,
      timeout: 0,
      noTax: true,
      noTipTax: true,
      noDeliveryTax: true,
      noServiceTax: true,
      countries: ['AT', 'UK'],
      e1: 1,
      account: {
        name: null,
        email: '',
        userName: null,
        maxDiscountPercentage: null,
        notes: null,
      },
      payments: ['cash', 'card', 'invoice', 'galaxycard', 'cheque', 'voucher', 'justeat',
        'hungryhouse', 'website', 'deliveroo', 'ubereats', 'amazon', 'cardmanual'],
      languages: [],
    };
  },
  watch: {
    'company.address.country': {
      handler(val) {
        if (val && val === 'AT') {
          this.company.currency = 'EUR';
          this.company.align = 'right';
          this.company.distanceUnit = 'meters';
          this.company.timezone = 'Europe/Vienna';
          this.company.defaultLanguage = 'de';
        }
        if (val && val === 'UK') {
          this.company.currency = 'GBP';
          this.company.align = 'left';
          this.company.distanceUnit = 'miles';
          this.company.timezone = 'Europe/London';
          this.company.defaultLanguage = 'en';
        }
      },
      deep: true,
    }
  },
  computed: {
    chargeTypesFormatted() {
      return this.chargeTypes.map(row => {
        const type = row;
        if (this.company.distanceUnit === 'meters') {
          type.text = type.text.replace('Miles', 'Meters');
          type.text = type.text.replace('Mile', 'Meter');
        }
        return type;
      });
    },
    openingValidation() {
      const isStartValid = this.validateTime(this.tempOpening.start);
      let isEndValid = this.validateTime(this.tempOpening.end);
      if (this.tempOpening.end === '0000') {
        return isEndValid = false;
      }
      return !!this.tempOpening.day && isStartValid && isEndValid;
    },
    mappedGroups() {
      return this.allPricingGroups.map(group => ({
        text: group.name,
        value: group.id,
      }));
    },
  },
  methods: {
    generateAddress(lines) {
      return lines.filter(line => !!line)
        .join(', ');
    },
    submitAddress(address) {
      this.company.address = {
        line1: address.line1.trim(),
        line2: address.line2.trim(),
        line3: address.line3.trim(),
        line4: address.line4.trim(),
        locality: address.locality.trim(),
        townCity: address.townCity.trim(),
        country: address.country.trim(),
        postalCode: address.postalCode.trim().toUpperCase(),
        latitude: address.latitude.trim(),
        longitude: address.longitude.trim(),
      };
      this.addressDialog = false;
      this.addressSet = true;
    },
    moveUp(arr, id) {
      const y = id--;
      var origin = arr[id]
      arr.splice(id, 1, arr[y])
      this.$set(arr, y, origin);
    },
    moveDown(arr, id) {
      const y = id++;
      var origin = arr[id]
      arr.splice(id, 1, arr[y])
      this.$set(arr, y, origin);
    },
    fetchPricingGroups(currency) {
      this.$http.post('pricinggroup/getall', {currency})
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allPricingGroups = res.body.pricingGroups;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
    formatDate(date) {
      return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    validateTime(time) {
      if (!time) return false;
      let valid = true;
      if (
        parseInt(time[0], 10) > 2 ||
        parseInt(time[0], 10) === 2 && parseInt(time[1], 10) > 3 ||
        parseInt(time[2], 10) > 5 ||
        !time[3]
      ) valid = false;
      if (time.length !== 4) valid = false;
      return valid;
    },
    //Opening Hours
    addHours() {
      this.openingTimes.push({
        day: '',
        start: '',
        end: '',
        isEdit: true,
      });
      this.editingHours = true;
      this.$forceUpdate();
    },
    copyOpening(time) {

      if (this.editingHours) {
        this.$set(time, 'day', this.tempOpening.day);
        this.$set(time, 'start', this.formatTime(this.tempOpening.start));
        this.$set(time, 'end', this.formatTime(this.tempOpening.end));
        this.$set(time, 'isEdit', false);
      }
      this.openingTimes.push({
        day: '',
        start: '',
        end: '',
        isEdit: true,
      });
      this.tempOpening = {
        day: time.day,
        start: this.formatTimeEdit(time.start),
        end: this.formatTimeEdit(time.end),
      };
      this.editingHours = true;
    },
    editOpening(time) {
      this.tempOpening = {
        day: time.day,
        start: this.formatTimeEdit(time.start),
        end: this.formatTimeEdit(time.end),
      };
      this.$set(time, 'isEdit', true);
      this.editingHours = true;
    },

    deleteOpening(index) {
      this.openingTimes.splice(index, 1);
      this.$forceUpdate();
    },

    formatTime(time) {
      const save = time.toString().replace(':', '');
      return `${save.slice(0, 2)}:${save.slice(2)}`;
    },
    formatTimeEdit(time) {
      return time.replace(':', '');
    },
    saveOpening(time) {
      this.$set(time, 'day', this.tempOpening.day);
      this.$set(time, 'start', this.formatTime(this.tempOpening.start));
      this.$set(time, 'end', this.formatTime(this.tempOpening.end));
      this.closeOpening(time);
    },

    closeOpening(time) {
      this.tempOpening = {
        day: '',
        start: '',
        end: '',
      };
      this.$set(time, 'isEdit', false);
      this.editingHours = false;
    },

    //Vat
    addVat() {
      this.vatRates.push({
        vat: '',
        isEdit: true,
      });
      this.editingVat = true;
      this.$forceUpdate();
    },
    editVat(vat) {
      this.tempVat = {
        vat: vat.vat,
      };
      this.$set(vat, 'isEdit', true);
      this.editingVat = true;
    },

    deleteVat(index) {
      this.vatRates.splice(index, 1);
      this.$forceUpdate();
    },

    saveVatEdit(vat) {
      this.$set(vat, 'vat', this.tempVat.vat);
      this.closeVatEdit(vat);
    },

    closeVatEdit(vat) {
      this.tempVat = {
        vat: '',
      };
      this.$set(vat, 'isEdit', false);
      this.editingVat = false;
    },

    //Charge by Miles
    addMiles() {
      this.miles.push({
        fromMiles: '',
        toMiles: '',
        charges: '',
        isEdit: true,
      });
      this.editingMiles = true;
      this.$forceUpdate();
    },
    editMiles(charge) {
      this.tempMiles = {
        fromMiles: charge.fromMiles,
        toMiles: charge.toMiles,
        charges: charge.charges,
      };
      this.$set(charge, 'isEdit', true);
      this.editingMiles = true;
    },

    deleteMiles(index) {
      this.miles.splice(index, 1);
      this.$forceUpdate();
    },

    saveMilesEdit(charge) {
      this.$set(charge, 'fromMiles', this.tempMiles.fromMiles);
      this.$set(charge, 'toMiles', this.tempMiles.toMiles);
      this.$set(charge, 'charges', this.tempMiles.charges);
      this.closeMilesEdit(charge);
    },

    closeMilesEdit(charge) {
      this.tempMiles = {
        fromMiles: '',
        toMiles: '',
        charges: '',
      };
      this.$set(charge, 'isEdit', false);
      this.editingMiles = false;
    },

    //Charge by Amount
    addAmount() {
      this.amounts.push({
        fromAmount: '',
        toAmount: '',
        charges: '',
        isEdit: true,
      });
      this.editingAmount = true;
      this.$forceUpdate();
    },
    editAmount(amount) {
      this.tempAmount = {
        fromAmount: amount.fromAmount,
        toAmount: amount.toAmount,
        charges: amount.charges,
      };
      this.$set(amount, 'isEdit', true);
      this.editingAmount = true;
    },

    deleteAmount(index) {
      this.amounts.splice(index, 1);
      this.$forceUpdate();
    },

    saveAmountEdit(amount) {
      this.$set(amount, 'fromAmount', this.tempAmount.fromAmount);
      this.$set(amount, 'toAmount', this.tempAmount.toAmount);
      this.$set(amount, 'charges', this.tempAmount.charges);
      this.closeAmountEdit(amount);
    },

    closeAmountEdit(amount) {
      this.tempAmount = {
        fromAmount: '',
        toAmount: '',
        charges: '',
      };
      this.$set(amount, 'isEdit', false);
      this.editingAmount = false;
    },
    submit() {
      const company = {...this.company};
      if (this.openingTimes.length > 0) {
        const openingDaysAndHours = this.openingTimes.map(time => ({
          day: time.day,
          start: time.start,
          end: time.end,
        }));
        Object.assign(company, {openingDaysAndHours});
      }
      if (!this.noTax && this.vatRates.length > 0) {
        Object.assign(company, {vatRates: this.vatRates.map(rate => rate.vat)});
      } else {
        Object.assign(company, {vatRates: null});
      }
      if (company.vatRates !== null) {
        company.vatRates = company.vatRates.map(vat => Number(vat));
      }
      if (company.address.country === 'AT') {
        if (company.vatRates === null) {
          this.err = this.$lang.errors.noVatRates;
          return;
        } else {
          const arr = company.vatRates.filter(rate => !this.allowedVatRates.at.includes(Number(rate)));
          if (company.address.country === 'AT' && arr.length > 0) {
            this.err = `${this.$lang.errors.wrongVAT}: ${this.allowedVatRates.at}`;
            return;
          }
        }
      }
      if (company.address.country === 'UK') {
        const arr = company.vatRates !== null ? company.vatRates.filter(rate => !this.allowedVatRates.uk.includes(Number(rate))) : [];
        if (arr.length > 0) {
          this.err = `${this.$lang.errors.wrongVatUK}: ${this.allowedVatRates.uk}`;
          return;
        }
      }
      company.address.postalCode = company.address.postalCode.trim().toUpperCase();
      this.company.address.postalCode = company.address.postalCode;

      let url = 'company/selfregister';

      const obj = {
        company,
        account: this.account,
      }

      obj.company.parentCompanyId = '5d94a1d98a271ccda4fa5317';

      console.log(obj);

      this.$http.post(url, obj)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.success = 'Company and User created successfully';
            console.log(res);
            setTimeout(() => {
              if (this.isEdit) {
                this.success = '';
              }
            }, 3000);
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
    init() {
      return new Promise((resolve) => {
        Promise.all([
          this.$http.get(`system/vatrates`)
            .then((res) => {
              const at = res.body.at.map(vat => Number(vat));
              const uk = res.body.uk.map(vat => Number(vat));
              const allowedVatRates = {
                at,
                uk,
              };
              this.allowedVatRates = {
                at,
                uk,
              };
              localStorage.setItem('allowedVatRates', JSON.stringify(allowedVatRates));
              return resolve();
            })
            .catch(err => {
              console.log(err);
              return resolve();
            }),
          this.$http.get('system/cuisines')
            .then((res) => {
              if (res.body.status === 'Success') {
                this.cuisines = res.body.cuisines.sort();
                return resolve();
              }
              return resolve();
            })
            .catch(err => {
              console.log(err);
              return resolve();
            }),
        ])
      })
    },
  },
  beforeDestroy() {
    Cookie.delete('uuid');
  },
  mounted() {
    Cookie.set('uuid', '', {expires: '72h'});
  },
  created() {
    Cookie.set('uuid', '', {expires: '72h'});
    this.init()
      .then(() => {
        this.show = true;
      });
  }
};
</script>

<style lang="scss" scoped>
.row {
  height: 100%;
}

h1 {
  font-size: 2.5rem;
}

.login-image {
  position: relative;
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: auto;
    min-width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  h1 {
    font-size: 1.8rem;
  }
}
</style>
<style lang="scss">
.required {
  .v-label:after {
    content: ' *';
    font-size: inherit;
    color: #f4511e !important;
  }
}

.v-messages {
  color: red !important;
  font-weight: bold;
  transform: translate(0, -3px);
}
</style>
<style lang="scss" scoped>
.radio-input {
  padding-top: 4px;

  p {
    padding-bottom: 0;
    margin-bottom: 0;
    color: rgba(0, 0, 0, .54);
  }

  .input-group {
    padding-top: 0 !important;
  }
}

.currency-wrap {
  padding-right: 16px;
}

.custom-table {
  max-width: 99.9%;

  .table {
    width: calc(100% - 1px);
  }

  .th-adj {
    margin-bottom: -15px;
    font-size: 16px;
  }

  table {
    th {
      padding: 6px 12px !important;
    }

    thead {
      tr {
        height: 42px !important;
        border-bottom: none !important;
      }
    }
  }

  tbody {
    tr {
      &:nth-of-type(odd) {
        background-color: #f9f9f9;
      }
    }

    td {
      padding: 0 12px !important;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
}

.id-for-s3 {
  color: rgba(0, 0, 0, .54);
  font-size: 16px;
}

@media only screen and (max-width: 960px) {
  .currency-wrap {
    padding-right: 0;
  }
}

.move-row {
  padding: 0 12px !important;
  width: 30px !important;
}
</style>



// WEBPACK FOOTER //
// SignUp.vue?57b4f53f